export default function DecorativeDivider() {
  return (
    <div className="flex items-center justify-center gap-3 my-4">
      <div className="h-px w-16 bg-gradient-to-r from-transparent to-accent-500/40" />
      <div className="w-2 h-2 rounded-full bg-accent-500" />
      <div className="h-px w-16 bg-gradient-to-l from-transparent to-accent-500/40" />
    </div>
  );
}